import { jsx as _jsx } from "react/jsx-runtime";
import { PosterImage } from "../styles";
export const Poster = ({ poster, blurred, }) => {
    if (!poster) {
        return null;
    }
    return _jsx(PosterImage, { src: poster, "$blurred": blurred, "aria-hidden": true });
};
export default Poster;
